/* unplugin-vue-components disabled */import script from "./Verification.vue?vue&type=script&setup=true&lang=js"
export * from "./Verification.vue?vue&type=script&setup=true&lang=js"

import "./Verification.vue?vue&type=style&index=0&id=66cb8516&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66cb8516"]])

export default __exports__